// Ported from mono-repo design-system LoadingIndicator (alias primary 700 / 50).
import {
	AfterViewInit,
	Component,
	ElementRef,
	ViewChild,
} from '@angular/core';
import {
	encodeUpshopLoadingSvg,
	generateUpshopLoadingConicGradientSvg,
	UPSHOP_LOADING_COLOR_BASE,
	UPSHOP_LOADING_COLOR_GRADIENT,
	UPSHOP_LOADING_PATH0,
	UPSHOP_LOADING_PATH1,
} from './upshop-loading-indicator-svg.util';

@Component({
	selector: 'sk-upshop-loading-indicator',
	templateUrl: './upshop-loading-indicator.component.html',
	styleUrls: ['./upshop-loading-indicator.component.scss'],
})
export class UpshopLoadingIndicatorComponent implements AfterViewInit {
	@ViewChild('shape0') shape0: ElementRef;
	@ViewChild('spin0') spin0: ElementRef;
	@ViewChild('shape1') shape1: ElementRef;
	@ViewChild('spin1') spin1: ElementRef;

	private readonly mask0Url: string;
	private readonly mask1Url: string;
	private readonly gradientUrl: string;
	private readonly gradientUrlReverse: string;

	constructor() {
		this.gradientUrl = encodeUpshopLoadingSvg(
			generateUpshopLoadingConicGradientSvg(UPSHOP_LOADING_COLOR_GRADIENT, UPSHOP_LOADING_COLOR_BASE)
		);
		this.gradientUrlReverse = encodeUpshopLoadingSvg(
			generateUpshopLoadingConicGradientSvg(UPSHOP_LOADING_COLOR_BASE, UPSHOP_LOADING_COLOR_GRADIENT)
		);
		this.mask0Url = encodeUpshopLoadingSvg(
			'<svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"><path d="' +
				UPSHOP_LOADING_PATH0 +
				'" fill="black"/></svg>'
		);
		this.mask1Url = encodeUpshopLoadingSvg(
			'<svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"><path d="' +
				UPSHOP_LOADING_PATH1 +
				'" fill="black"/></svg>'
		);
	}

	ngAfterViewInit(): void {
		this.applyMask(this.shape0, this.mask0Url);
		this.applyMask(this.shape1, this.mask1Url);
		this.applyGradient(this.spin0, this.gradientUrl);
		this.applyGradient(this.spin1, this.gradientUrlReverse);
	}

	private applyMask(host: ElementRef, url: string): void {
		if (!host || !host.nativeElement) {
			return;
		}
		const el = host.nativeElement;
		el.style.setProperty('-webkit-mask-image', 'url("' + url + '")');
		el.style.setProperty('mask-image', 'url("' + url + '")');
		el.style.setProperty('-webkit-mask-size', '100% 100%');
		el.style.setProperty('mask-size', '100% 100%');
		el.style.setProperty('-webkit-mask-repeat', 'no-repeat');
		el.style.setProperty('mask-repeat', 'no-repeat');
	}

	private applyGradient(host: ElementRef, url: string): void {
		if (!host || !host.nativeElement) {
			return;
		}
		const el = host.nativeElement;
		el.style.setProperty('background-color', UPSHOP_LOADING_COLOR_BASE);
		el.style.setProperty('background-image', 'url("' + url + '")');
		el.style.setProperty('background-size', '100% 100%');
	}
}
